import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Icon,
  ICONS,
  PLATFORM_THEME_COLORS,
  Typography,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';

import {
  IconWrapper,
  ConflictWrapper,
} from 'src/pages/gantt/components/time-stripe-adding-modal/time-stripe-adding-modal.styles';

const PlacementConflictRow: React.FC<{ icon: string; title: string }> = ({ icon, title }) => {
  const { t } = useTranslation('gantt');

  return (
    <ConflictWrapper>
      <IconWrapper>
        <Icon
          rightMargin={false}
          icon={icon}
          color={
            icon === ICONS.errorCircleSolid
              ? PLATFORM_THEME_COLORS.tone.red
              : PLATFORM_THEME_COLORS.primary.blue
          }
          size={24}
        />
      </IconWrapper>
      <Typography color={PLATFORM_THEME_COLORS.primary.grey} size={TYPOGRAPHY_SIZE.small}>
        {t('messages.addedTimeStripeFor')}{' '}
        <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey} weight="bold">
          {title}.
        </Typography>
      </Typography>
    </ConflictWrapper>
  );
};

export default PlacementConflictRow;
